import { Component, OnInit } from '@angular/core';
import { CustomPage } from '../custom-page.types';
import { CorePageBaseComponent } from '@workflow/dynamic-render/page/shared/core-page-base.component';
import { LogicService } from '@workflow/service/logic/logic.service';
import { WorkflowPageNavigationService } from '@workflow/service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowWidgetEventServiceService } from '@workflow/widget/workflow-widget-event.service';

export interface SlideOutContent {
  title: string;
  header: string;
  description: string;
}
@CustomPage('slideout')
@Component({
  selector: 'ecp-slideout-page',
  templateUrl: `slideout-page.component.html`,
  standalone: false
})
export class SlideoutPageComponent extends CorePageBaseComponent implements OnInit {
  public isOpen = false;
  public slideoutContent: SlideOutContent;

  constructor(
    public workflowPageNavigationService: WorkflowPageNavigationService,
    public readonly EventService: WorkflowWidgetEventServiceService,
    private readonly logicService: LogicService
  ) {
    super(workflowPageNavigationService, EventService);
  }

  public ngOnInit(): void {
    this.flow.onPageLoad();
    this.workflowPageNavigationService.updateNavState(this.page, true);
    this.workflowPageNavigationService.reset();
    this.onLoadAsync((res) => {
      this.slideoutContent = res;
    });
  }

  public openSlideInPanel() {
    this.isOpen = true;
  }
  protected readonly onLoadAsync = (cb: (res: SlideOutContent) => void): void => {
    if (this.page?.config?.onLoad) {
      const config = this.logicService.evaluate<Promise<SlideOutContent>>(
        this.page.config.onLoad,
        {
          page: this.page
        },
        'single'
      );
      if (config && config[0]) {
        config[0].then(cb);
      }
    }
  };
}
